import axios from 'axios';

const IF_CONVENTION_ACCOUNT_ID = 7;

// Create dedicated axios instance for IF Convention functionality
const ifConventionAxios = axios.create({
  baseURL: process.env.REACT_APP_IF_CONVENTION_API_URL || 'http://api.pigeonconnect.charmedcoder.com/api/',
  headers: {
    Authorization: `Bearer ${IF_CONVENTION_ACCOUNT_ID}`
  }
});

// IF Convention-specific interceptors
ifConventionAxios.interceptors.request.use(
  (config) => {
    // Check if we have participant auth in sessionStorage for IF Convention
    const participantAuth = sessionStorage.getItem('participantAuth');
    
    if (participantAuth) {
      try {
        const auth = JSON.parse(participantAuth);
        
        if (auth.authToken && auth.authToken.Token) {
          // Use Token scheme for authenticated participant requests
          config.headers.Authorization = `Token ${auth.authToken.Token}_${IF_CONVENTION_ACCOUNT_ID}`;
        }
      } catch (error) {
        console.error('Failed to parse participant auth:', error);
      }
    } else {
      // Fallback to Bearer token for IF Convention
      config.headers.Authorization = `Bearer ${IF_CONVENTION_ACCOUNT_ID}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ifConventionAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid for IF Convention
      sessionStorage.removeItem('participantAuth');
      // Redirect to IF Convention login
      if (window.location.pathname.startsWith('/race/')) {
        window.location.href = '/race/signin';
      }
    }
    return Promise.reject(error);
  }
);

export default ifConventionAxios;